// src/components/Services.jsx

import React from 'react';

const MarketGrowthStrategy = () => {
  return (
    <div>
      <h2 className="text-4xl font-bold text-black mb-5">
   Market And Growth<span className="text-[#680099] ml-2 font-bold">Strategy</span>
</h2>

<h5 className="text-xl font-bold text-black mt-7 mb-3"> Agent Acquisition Plan</h5>


      {/* Container for the two boxes */}
      <div style={boxesContainerStyle}>
        {/* Left box */}
        <div style={leftBoxStyle}>
          <div style={boxHeadingStyle}>Strategy</div>
          <p style={boxContentStyle}> Organic Growth</p>
          <p style={boxContentStyle}> Incentived For Early Adopters</p>
          <p style={boxContentStyle}> Agent Partnerships</p>

        </div>

        {/* Right box */}
        <div style={rightBoxStyle}>
          <div style={boxHeadingStyle}>Description</div>
          <p style={boxContentStyle}> Leverage 10 Initial Agents As a Foundation; Target 10-15 New Agents/Month, Increasing To 20-30 Agents Later.</p>
          <p style={boxContentStyle}> Offer Competitive Commissions And Bonuses Tp Attract And Retain High Engagement Agents.</p>
          <p style={boxContentStyle}> Relationship Management To Drive Agent Loyalty And Long-Term Platform Use.</p>

        </div>
      </div>

      <br/>

      <h5 className="text-xl font-bold text-black mt-7 mb-3"> Digital Marketing Initiatives</h5>


      {/* Container for the two boxes */}
      <div style={boxesContainerStyle}>
        {/* Left box */}
        <div style={leftBoxStyle}>
          <div style={boxHeadingStyle}> Channel</div>
          <p style={boxContentStyle}> SEO And Content Marketing</p>
          <p style={boxContentStyle}> Social Media Campaigns</p>

        </div>

        {/* Right box */}
        <div style={rightBoxStyle}>
          <div style={boxHeadingStyle}>Focus</div>
          <p style={boxContentStyle}> Improve Search Visibility And Website Traffic; Attract Agents Looking For Customizable Travel Solutions.</p>
          <p style={boxContentStyle}> LinkedIn And B2B Forums For Agents Engagement; Brand Building In The B2C Market.</p>

        </div>
      </div>

      
    </div>
  );
};

const boxesContainerStyle = {
  display: 'flex',  // Align items side by side
  gap: '20px',  // Space between the boxes
  marginTop: '19px',  // Optional: space between heading and boxes

};

const leftBoxStyle = {
  flex: 1,  // Takes up available space, but narrower due to specific width
  maxWidth: '25%',  // Adjust width to make it narrower
  backgroundColor: '#fbf4ff',  // Background color for the box
  borderRadius: '30px',
  padding: '0px',
};

const rightBoxStyle = {
  flex: 1,  // Takes up available space
  backgroundColor: '#fbf4ff',  // Background color for the box
  borderRadius: '30px',
  padding: '0px',
};

const boxHeadingStyle = {
  backgroundColor: '#321e5d',  // Background color for the heading
  color: 'white',
  padding: '10px',
  borderRadius: '30px 30px 0px 0px',   
  fontSize: '18px',
  fontWeight: 'bold',  
  textAlign: 'center',

  
};

const boxContentStyle = {
  
  textAlign: 'center',
  marginTop: '20px',
  fontSize: '17px'
};

const bulletPointsStyle = {
  listStyleType: 'disc',  // Bullet points (disc)
  paddingLeft: '20px',    // Indentation for the list
  marginTop: '19px',      // Space above the list
};

const bulletPointItemStyle = {
  fontSize: '18px',       // Font size for the bullet point text
  marginBottom: '10px',   // Space between each bullet point
  lineHeight: '1.6',      // Line height for readability
};

export default MarketGrowthStrategy;
